/* tslint:disable */
/* This file should be ignored by git and the .svg file checked in instead.
 * This file was generated with 'svg-gen'. Manual changes will be lost. */
import React from 'react';
import { createIcon } from '../../createIcon';
export var SharedFoldersIcon = createIcon("SharedFoldersIcon", function (title) {
  var _color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '#000';
  return /*#__PURE__*/React.createElement("svg", {
    "data-replace-color": _color,
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("path", {
    d: "M5.656 12.219H2.03m11.126-6.563V3.781a.937.937 0 00-.937-.937H5.656v-.938A.937.937 0 004.72.97H1.906a.937.937 0 00-.937.937v9.25a1.063 1.063 0 002.085.274l1.47-5.096a.938.938 0 01.9-.678h8.67",
    stroke: _color,
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.125 8.375a1 1 0 102 0 1 1 0 00-2 0v0Zm2.75 3.25a1.75 1.75 0 00-3.5 0v.75h.75l.25 2.5h1.5l.25-2.5h.75v-.75Zm1.25-3.25a1 1 0 102 0 1 1 0 00-2 0v0Zm-.5 4h.5l.25 2.5h1.5l.25-2.5h.75v-.75a1.75 1.75 0 00-3.25-.9",
    stroke: _color,
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}, {
  "replaceColor": true
});